export const reportHelpPartnerText = {
  titleText: 'Bantu Rekan Report',
  searchPlaceholder: 'Cari nama host atau operator disini...',
  buttonExportText: 'Export',
  selectRoomPlaceholder: 'Pilih Ruangan',
  startDatePlaceholder: 'Tanggal Mulai',
  endDatePlaceholder: 'Tanggal Selesai',
};
